export default __webpack_public_path__ + "static/user-img-2-2adc650c336275abbeb7aab9635ea28f.png";